import { render, staticRenderFns } from "./SubSkillAccuracyTable.vue?vue&type=template&id=1c2a7503&scoped=true&"
import script from "./SubSkillAccuracyTable.vue?vue&type=script&lang=js&"
export * from "./SubSkillAccuracyTable.vue?vue&type=script&lang=js&"
import style0 from "./SubSkillAccuracyTable.vue?vue&type=style&index=0&id=1c2a7503&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2a7503",
  null
  
)

export default component.exports